import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import EntityHeader from "./common/EntityHeader";
import FieldDisplay from "./common/FieldDisplay";
import { getFieldName, getFieldText } from "../scripts/helperScripts";
import { getContact } from "./services/soar";

function ContactMethodsEntity({ contact, ...rest }) {
  const [contactMethods, setContactMethods] = useState({});
  const isMountedRef = useRef(true);
  const navigate = useNavigate();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  //Route Access Protection
  useEffect(() => {
    if (safyInfo) {
      const modules = safyInfo.user.modules;
      if (
        modules.includes("My Caseload") === false &&
        modules.includes("Team Caseload") === false &&
        modules.includes("Foster Homes") === false
      ) {
        navigate("/");
      }
    } else navigate("/");
  });

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    if (contact) {
      const contactMethodsObj = {};

      if (contact.telephone2) contactMethodsObj.telephone2 = contact.telephone2;

      if (contact.mobilephone)
        contactMethodsObj.mobilephone = contact.mobilephone;

      if (contact.sor_text) contactMethodsObj.sor_text = contact.sor_text;

      if (contact.telephone1) contactMethodsObj.telephone1 = contact.telephone1;

      if (contact.fax) contactMethodsObj.fax = contact.fax;

      if (contact.emailaddress1)
        contactMethodsObj.emailaddress1 = contact.emailaddress1;

      if (contact.emailaddress2)
        contactMethodsObj.emailaddress2 = contact.emailaddress2;

      if (contact.ccx_primarycontactmethod)
        contactMethodsObj.ccx_primarycontactmethod =
          contact.ccx_primarycontactmethod;

      if (contact.ccx_secondarycontactmethod)
        contactMethodsObj.ccx_secondarycontactmethod =
          contact.ccx_secondarycontactmethod;

      setContactMethods(contactMethodsObj);
    }
  }, [contact]);

  const addNew = () => {
    navigate(`/contact/${contact.contactid}`);
  };

  return (
    <>
      <EntityHeader
        title={"Contact Methods"}
        add={addNew}
        {...rest}
        body={
          <>
            {Object.keys(contactMethods).length > 0 && (
              <div className={"d-block p-2"}>
                <Card bg="dark" className="card-safy">
                  <Card.Header
                    className="p-0 ps-2 bg-safy1-1"
                    style={{ color: "white" }}
                  >
                    <div className="row">
                      <div className="col-10 ps-4 pt-1">Contact Methods</div>
                      <div className="col-2">
                        <i
                          className="fas fa-pen float-end p-2"
                          onClick={addNew}
                        ></i>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body className={"p-2 card-body-safy"}>
                    {contactMethods.telephone2 && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Home Phone"
                            value={contactMethods.telephone2}
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                    {contactMethods.mobilephone && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Mobile Phone"
                            value={contactMethods.mobilephone}
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                    {contactMethods.telephone1 && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Business Phone"
                            value={contactMethods.telephone1}
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                    {contactMethods.fax && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Fax"
                            value={contactMethods.fax}
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                    {contactMethods.emailaddress1 && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Email Address 1"
                            value={
                              <a
                                href={`mailto:${contactMethods.emailaddress1}`}
                              >
                                {contactMethods.emailaddress1}
                              </a>
                            }
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                    {contactMethods.emailaddress2 && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Email Address 2"
                            value={
                              <a
                                href={`mailto:${contactMethods.emailaddress2}`}
                              >
                                {contactMethods.emailaddress2}
                              </a>
                            }
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                    {contactMethods.ccx_primarycontactmethod && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Primary Contact Method"
                            value={getFieldName(
                              contactMethods.ccx_primarycontactmethod
                            )}
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                    {contactMethods.ccx_secondarycontactmethod && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Secondary Contact Method"
                            value={getFieldName(
                              contactMethods.ccx_secondarycontactmethod
                            )}
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                    {contactMethods.sor_text && (
                      <div className="row">
                        <div className="col">
                          <FieldDisplay
                            label="Can Text"
                            value={getFieldName(contactMethods.sor_text)}
                          ></FieldDisplay>
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </div>
            )}
          </>
        }
      />
    </>
  );
}

export default ContactMethodsEntity;
